// Generic Server-Sent-Events chunk parser shared by every feature that consumes an
// SSE stream from the API (chat, dashboard, ...). Reads raw `event: `/`data: ` frames
// off a fetch Response body and hands each parsed frame to the caller — callers own
// their own typed event dispatch (see chat/services/chatApi.ts's SseEvent union), so
// this stays generic and has no knowledge of any particular feature's event shapes.
export async function consumeSseStream(
  res: Response,
  onEvent: (event: string, data: unknown) => void,
): Promise<void> {
  const reader = res.body!.getReader()
  const decoder = new TextDecoder()
  let buffer = ''

  while (true) {
    const { done, value } = await reader.read()
    if (done) break

    buffer += decoder.decode(value, { stream: true })
    const blocks = buffer.split('\n\n')
    buffer = blocks.pop() ?? ''

    for (const block of blocks) {
      const lines = block.split('\n')
      let eventType = ''
      let data = ''
      for (const line of lines) {
        if (line.startsWith('event: ')) eventType = line.slice(7).trim()
        else if (line.startsWith('data: ')) data = line.slice(6).trim()
      }
      if (!eventType || !data) continue
      try {
        onEvent(eventType, JSON.parse(data))
      } catch {
        // ignore malformed SSE blocks
      }
    }
  }
}
